import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { string, func, array, object } from 'prop-types';
import { replace, isEmpty, filter, includes } from 'lodash';
import {
    FlexContainer,
    Row,
    SalesChannelSelect,
    Button,
    CompanyGroupsSelect
} from '../../common';

const SpaceBetween = styled.div`
    width: ${({ width }) => width};
`;

const Filters = ({
    currentValue,
    onChangeSalesChannels,
    onChangeFilters,
    onChangeSelectedCompanyGroup,
    selectedCompanyGroup,
    initialSaleChannelSelected
}) => {
    const [showSalesChannelSelect, setShowSalesChannelSelect] = useState(true);

    useEffect(() => {
        setShowSalesChannelSelect(false);
        setTimeout(() => {
            setShowSalesChannelSelect(true);
        }, 50);
    }, [selectedCompanyGroup]);

    const fullWidth = currentValue === '100%';
    const spaceBetweenWidth = fullWidth ? '0px' : '13px';

    const salesChannelFilteredOptions = options => filter(options, ({ kind }) => includes(selectedCompanyGroup, kind));

    return (
        <FlexContainer padding={23}>
            <Row border='1px solid #eaeaea' borderRadius={3} padding='3px 13px'>
                <CompanyGroupsSelect width={currentValue} onChange={onChangeSelectedCompanyGroup} initialValue={{ label: 'Jumbo', value: 'Jumbo' }} />
                <SpaceBetween width={spaceBetweenWidth} />
                {
                    showSalesChannelSelect && (
                        <SalesChannelSelect
                            native
                            label='Tienda'
                            style={{ width: `${parseInt(replace(currentValue, '%', '')) * 2}%` }}
                            onChange={values => onChangeSalesChannels(values)}
                            salesChannel={initialSaleChannelSelected}
                            customizeOptions={options => {
                                if (isEmpty(selectedCompanyGroup)) return options;
                                return salesChannelFilteredOptions(options);
                            }}
                        />
                    )
                }
                <SpaceBetween width={spaceBetweenWidth} />
                <FlexContainer
                    width={fullWidth ? '100%' : undefined}
                    align='flex-end'
                    mB={10}
                >
                    <Button
                        text='Buscar'
                        onClick={onChangeFilters}
                    />
                </FlexContainer>
            </Row>
        </FlexContainer>
    );
};

Filters.propTypes = {
    currentValue: string,
    onChangeSalesChannels: func,
    onChangeFilters: func,
    onChangeSelectedCompanyGroup: func,
    selectedCompanyGroup: array,
    initialSaleChannelSelected: object
};

export default Filters;
